// general Settings Saga
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_VAT_PERIOD_LIST,
  GET_VAT_PERIOD_DETAILS,
  ADD_VAT_PERIOD,
  UPDATE_VAT_PERIOD,
  DELETE_VAT_PERIOD,
  GET_RENEWAL_FREQUENCIES_LIST,
  GET_RENEWAL_FREQUENCIES_DETAILS,
  ADD_RENEWAL_FREQUENCIES,
  UPDATE_RENEWAL_FREQUENCIES,
  DELETE_RENEWAL_FREQUENCIES,
  GET_UNIT_FREQUENCIES_LIST,
  GET_UNIT_FREQUENCIES_DETAILS,
  ADD_UNIT_FREQUENCIES,
  UPDATE_UNIT_FREQUENCIES,
  DELETE_UNIT_FREQUENCIES,
  GET_MASTER_TIME_FRAME_LIST,
  GET_MASTER_TIME_FRAME_DETAILS,
  ADD_MASTER_TIME_FRAME,
  UPDATE_MASTER_TIME_FRAME,
  DELETE_MASTER_TIME_FRAME,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER,
} from "./actionType";

import {
  getVatPeriodListSuccess,
  getVatPeriodListFailure,
  getVatPeriodDetailsSuccess,
  getVatPeriodDetailsFailure,
  addVatPeriodSuccess,
  addVatPeriodFailure,
  updateVatPeriodSuccess,
  updateVatPeriodFailure,
  deleteVatPeriodSuccess,
  deleteVatPeriodFailure,
  getRenewalFrequenciesListSuccess,
  getRenewalFrequenciesListFailure,
  getRenewalFrequenciesDetailsSuccess,
  getRenewalFrequenciesDetailsFailure,
  addRenewalFrequenciesSuccess,
  addRenewalFrequenciesFailure,
  updateRenewalFrequenciesSuccess,
  updateRenewalFrequenciesFailure,
  deleteRenewalFrequenciesSuccess,
  deleteRenewalFrequenciesFailure,
  getUnitFrequenciesListSuccess,
  getUnitFrequenciesListFailure,
  getUnitFrequenciesDetailsSuccess,
  getUnitFrequenciesDetailsFailure,
  addUnitFrequenciesSuccess,
  addUnitFrequenciesFailure,
  updateUnitFrequenciesSuccess,
  updateUnitFrequenciesFailure,
  deleteUnitFrequenciesSuccess,
  deleteUnitFrequenciesFailure,
  getMasterTimeFrameListSuccess,
  getMasterTimeFrameListFailure,
  getMasterTimeFrameDetailsSuccess,
  getMasterTimeFrameDetailsFailure,
  addMasterTimeFrameSuccess,
  addMasterTimeFrameFailure,
  updateMasterTimeFrameSuccess,
  updateMasterTimeFrameFailure,
  deleteMasterTimeFrameSuccess,
  deleteMasterTimeFrameFailure,
  getConfigItemsCompanyEditableListSuccess,
  getConfigItemsCompanyEditableListFailure,
  getLocalSettingsMasterConfigListSuccess,
  getLocalSettingsMasterConfigListFailure,
  updateLocalSettingsMasterConfigToggleSuccess,
  updateLocalSettingsMasterConfigToggleFailure,
  getLocalSettingsMasterConfigUserListSuccess,
  getLocalSettingsMasterConfigUserListFailure,
  updateLocalSettingsMasterConfigUserSuccess,
  updateLocalSettingsMasterConfigUserFailure,
} from "./action";

import {
  getVatPeriodListApi,
  getVatPeriodDetailsApi,
  addVatPeriodApi,
  updateVatPeriodApi,
  deleteVatPeriodApi,
  getRenewalFrequenciesListApi,
  getRenewalFrequenciesDetailsApi,
  addRenewalFrequenciesApi,
  updateRenewalFrequenciesApi,
  deleteRenewalFrequenciesApi,
  getUnitFrequenciesListApi,
  getUnitFrequenciesDetailsApi,
  addUnitFrequenciesApi,
  updateUnitFrequenciesApi,
  deleteUnitFrequenciesApi,
  getMasterTimeFrameListApi,
  getMasterTimeFrameDetailsApi,
  addMasterTimeFrameApi,
  updateMasterTimeFrameApi,
  deleteMasterTimeFrameApi,
  getLocalSettingsMasterConfigListApi,
  getConfigItemsCompanyEditableListApi,
  updateLocalSettingsMasterConfigToggleApi,
  getLocalSettingsMasterConfigUserListApi,
  updateLocalSettingsMasterConfigUserApi,
} from "../../helpers/fakebackend_helper";

function* getVatPeriodListSaga() {
  try {
    const response = yield call(getVatPeriodListApi);
    yield put(getVatPeriodListSuccess(response));
  } catch (error) {
    yield put(getVatPeriodListFailure(error));
  }
}

function* watchGetVatPeriodListSaga() {
  yield takeEvery(GET_VAT_PERIOD_LIST, getVatPeriodListSaga);
}

function* getVatPeriodDetailsSaga({ payload }) {
  try {
    const response = yield call(getVatPeriodDetailsApi, payload);
    yield put(getVatPeriodDetailsSuccess(response));
  } catch (error) {
    yield put(getVatPeriodDetailsFailure(error));
  }
}

function* watchGetVatPeriodDetailsSaga() {
  yield takeEvery(GET_VAT_PERIOD_DETAILS, getVatPeriodDetailsSaga);
}

function* addVatPeriodSaga({ payload }) {
  try {
    const response = yield call(addVatPeriodApi, payload);
    yield put(addVatPeriodSuccess(response));
  } catch (error) {
    yield put(addVatPeriodFailure(error));
  }
}

function* watchAddVatPeriodSaga() {
  yield takeEvery(ADD_VAT_PERIOD, addVatPeriodSaga);
}

function* updateVatPeriodSaga({ payload }) {
  try {
    const response = yield call(updateVatPeriodApi, payload);
    yield put(updateVatPeriodSuccess(response));
  } catch (error) {
    yield put(updateVatPeriodFailure(error));
  }
}

function* watchUpdateVatPeriodSaga() {
  yield takeEvery(UPDATE_VAT_PERIOD, updateVatPeriodSaga);
}

function* deleteVatPeriodSaga({ payload }) {
  try {
    const response = yield call(deleteVatPeriodApi, payload);
    yield put(deleteVatPeriodSuccess(response));
  } catch (error) {
    yield put(deleteVatPeriodFailure(error));
  }
}

function* watchDeleteVatPeriodSaga() {
  yield takeEvery(DELETE_VAT_PERIOD, deleteVatPeriodSaga);
}

function* getRenewalFrequenciesListSaga() {
  try {
    const response = yield call(getRenewalFrequenciesListApi);
    yield put(getRenewalFrequenciesListSuccess(response));
  } catch (error) {
    yield put(getRenewalFrequenciesListFailure(error));
  }
}

function* watchGetRenewalFrequenciesListSaga() {
  yield takeEvery(GET_RENEWAL_FREQUENCIES_LIST, getRenewalFrequenciesListSaga);
}

function* getRenewalFrequenciesDetailsSaga({ payload }) {
  try {
    const response = yield call(getRenewalFrequenciesDetailsApi, payload);
    yield put(getRenewalFrequenciesDetailsSuccess(response));
  } catch (error) {
    yield put(getRenewalFrequenciesDetailsFailure(error));
  }
}

function* watchGetRenewalFrequenciesDetailsSaga() {
  yield takeEvery(
    GET_RENEWAL_FREQUENCIES_DETAILS,
    getRenewalFrequenciesDetailsSaga
  );
}

function* addRenewalFrequenciesSaga({ payload }) {
  try {
    const response = yield call(addRenewalFrequenciesApi, payload);
    yield put(addRenewalFrequenciesSuccess(response));
  } catch (error) {
    yield put(addRenewalFrequenciesFailure(error));
  }
}

function* watchAddRenewalFrequenciesSaga() {
  yield takeEvery(ADD_RENEWAL_FREQUENCIES, addRenewalFrequenciesSaga);
}

function* updateRenewalFrequenciesSaga({ payload }) {
  try {
    const response = yield call(updateRenewalFrequenciesApi, payload);
    yield put(updateRenewalFrequenciesSuccess(response));
  } catch (error) {
    yield put(updateRenewalFrequenciesFailure(error));
  }
}

function* watchUpdateRenewalFrequenciesSaga() {
  yield takeEvery(UPDATE_RENEWAL_FREQUENCIES, updateRenewalFrequenciesSaga);
}

function* deleteRenewalFrequenciesSaga({ payload }) {
  try {
    const response = yield call(deleteRenewalFrequenciesApi, payload);
    yield put(deleteRenewalFrequenciesSuccess(response));
  } catch (error) {
    yield put(deleteRenewalFrequenciesFailure(error));
  }
}

function* watchDeleteRenewalFrequenciesSaga() {
  yield takeEvery(DELETE_RENEWAL_FREQUENCIES, deleteRenewalFrequenciesSaga);
}

function* getUnitFrequenciesListSaga() {
  try {
    const response = yield call(getUnitFrequenciesListApi);
    yield put(getUnitFrequenciesListSuccess(response));
  } catch (error) {
    yield put(getUnitFrequenciesListFailure(error));
  }
}

function* watchGetUnitFrequenciesListSaga() {
  yield takeEvery(GET_UNIT_FREQUENCIES_LIST, getUnitFrequenciesListSaga);
}

function* getUnitFrequenciesDetailsSaga({ payload }) {
  try {
    const response = yield call(getUnitFrequenciesDetailsApi, payload);
    yield put(getUnitFrequenciesDetailsSuccess(response));
  } catch (error) {
    yield put(getUnitFrequenciesDetailsFailure(error));
  }
}

function* watchGetUnitFrequenciesDetailsSaga() {
  yield takeEvery(GET_UNIT_FREQUENCIES_DETAILS, getUnitFrequenciesDetailsSaga);
}

function* addUnitFrequenciesSaga({ payload }) {
  try {
    const response = yield call(addUnitFrequenciesApi, payload);
    yield put(addUnitFrequenciesSuccess(response));
  } catch (error) {
    yield put(addUnitFrequenciesFailure(error));
  }
}

function* watchAddUnitFrequenciesSaga() {
  yield takeEvery(ADD_UNIT_FREQUENCIES, addUnitFrequenciesSaga);
}

function* updateUnitFrequenciesSaga({ payload }) {
  try {
    const response = yield call(updateUnitFrequenciesApi, payload);
    yield put(updateUnitFrequenciesSuccess(response));
  } catch (error) {
    yield put(updateUnitFrequenciesFailure(error));
  }
}

function* watchUpdateUnitFrequenciesSaga() {
  yield takeEvery(UPDATE_UNIT_FREQUENCIES, updateUnitFrequenciesSaga);
}

function* deleteUnitFrequenciesSaga({ payload }) {
  try {
    const response = yield call(deleteUnitFrequenciesApi, payload);
    yield put(deleteUnitFrequenciesSuccess(response));
  } catch (error) {
    yield put(deleteUnitFrequenciesFailure(error));
  }
}

function* watchDeleteUnitFrequenciesSaga() {
  yield takeEvery(DELETE_UNIT_FREQUENCIES, deleteUnitFrequenciesSaga);
}

function* getMasterTimeFrameListSaga() {
  try {
    const response = yield call(getMasterTimeFrameListApi);
    yield put(getMasterTimeFrameListSuccess(response));
  } catch (error) {
    yield put(getMasterTimeFrameListFailure(error));
  }
}

function* watchGetMasterTimeFrameListSaga() {
  yield takeEvery(GET_MASTER_TIME_FRAME_LIST, getMasterTimeFrameListSaga);
}

function* getMasterTimeFrameDetailsSaga({ payload }) {
  try {
    const response = yield call(getMasterTimeFrameDetailsApi, payload);
    yield put(getMasterTimeFrameDetailsSuccess(response));
  } catch (error) {
    yield put(getMasterTimeFrameDetailsFailure(error));
  }
}

function* watchGetMasterTimeFrameDetailsSaga() {
  yield takeEvery(GET_MASTER_TIME_FRAME_DETAILS, getMasterTimeFrameDetailsSaga);
}

function* addMasterTimeFrameSaga({ payload }) {
  try {
    const response = yield call(addMasterTimeFrameApi, payload);
    yield put(addMasterTimeFrameSuccess(response));
  } catch (error) {
    yield put(addMasterTimeFrameFailure(error));
  }
}

function* watchAddMasterTimeFrameSaga() {
  yield takeEvery(ADD_MASTER_TIME_FRAME, addMasterTimeFrameSaga);
}

function* updateMasterTimeFrameSaga({ payload }) {
  try {
    const response = yield call(updateMasterTimeFrameApi, payload);
    yield put(updateMasterTimeFrameSuccess(response));
  } catch (error) {
    yield put(updateMasterTimeFrameFailure(error));
  }
}

function* watchUpdateMasterTimeFrameSaga() {
  yield takeEvery(UPDATE_MASTER_TIME_FRAME, updateMasterTimeFrameSaga);
}

function* deleteMasterTimeFrameSaga({ payload }) {
  try {
    const response = yield call(deleteMasterTimeFrameApi, payload);
    yield put(deleteMasterTimeFrameSuccess(response));
  } catch (error) {
    yield put(deleteMasterTimeFrameFailure(error));
  }
}

function* watchDeleteMasterTimeFrameSaga() {
  yield takeEvery(DELETE_MASTER_TIME_FRAME, deleteMasterTimeFrameSaga);
}

function* getLocalSettingsMasterConfigListSaga() {
  try {
    const response = yield call(getLocalSettingsMasterConfigListApi);
    yield put(getLocalSettingsMasterConfigListSuccess(response));
  } catch (error) {
    yield put(getLocalSettingsMasterConfigListFailure(error));
  }
}

function* watchGetLocalSettingsMasterConfigListSaga() {
  yield takeEvery(
    GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST,
    getLocalSettingsMasterConfigListSaga
  );
}

function* getConfigItemsCompanyEditableListSaga() {
  try {
    const response = yield call(getConfigItemsCompanyEditableListApi);
    yield put(getConfigItemsCompanyEditableListSuccess(response));
  } catch (error) {
    yield put(getConfigItemsCompanyEditableListFailure(error));
  }
}

function* watchGetConfigItemsCompanyEditableListSaga() {
  yield takeEvery(
    GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST,
    getConfigItemsCompanyEditableListSaga
  );
}

function* updateLocalSettingsMasterConfigToggleSaga({ payload }) {
  try {
    const response = yield call(
      updateLocalSettingsMasterConfigToggleApi,
      payload
    );
    yield put(updateLocalSettingsMasterConfigToggleSuccess(response));
  } catch (error) {
    yield put(updateLocalSettingsMasterConfigToggleFailure(error));
  }
}

function* watchUpdateLocalSettingsMasterConfigToggleSaga() {
  yield takeEvery(
    UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE,
    updateLocalSettingsMasterConfigToggleSaga
  );
}

function* getLocalSettingsMasterConfigUserListSaga() {
  try {
    const response = yield call(getLocalSettingsMasterConfigUserListApi);
    yield put(getLocalSettingsMasterConfigUserListSuccess(response));
  } catch (error) {
    yield put(getLocalSettingsMasterConfigUserListFailure(error));
  }
}

function* watchGetLocalSettingsMasterConfigUserListSaga() {
  yield takeEvery(
    GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST,
    getLocalSettingsMasterConfigUserListSaga
  );
}

function* updateLocalSettingsMasterConfigUserSaga({ payload }) {
  try {
    const response = yield call(
      updateLocalSettingsMasterConfigUserApi,
      payload
    );
    yield put(updateLocalSettingsMasterConfigUserSuccess(response));
  } catch (error) {
    yield put(updateLocalSettingsMasterConfigUserFailure(error));
  }
}

function* watchUpdateLocalSettingsMasterConfigUserSaga() {
  yield takeEvery(
    UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER,
    updateLocalSettingsMasterConfigUserSaga
  );
}

export default function* GeneralSettings() {
  yield all([
    fork(watchGetVatPeriodListSaga),
    fork(watchGetVatPeriodDetailsSaga),
    fork(watchAddVatPeriodSaga),
    fork(watchUpdateVatPeriodSaga),
    fork(watchDeleteVatPeriodSaga),
    fork(watchGetRenewalFrequenciesListSaga),
    fork(watchGetRenewalFrequenciesDetailsSaga),
    fork(watchAddRenewalFrequenciesSaga),
    fork(watchUpdateRenewalFrequenciesSaga),
    fork(watchDeleteRenewalFrequenciesSaga),
    fork(watchGetUnitFrequenciesListSaga),
    fork(watchGetUnitFrequenciesDetailsSaga),
    fork(watchAddUnitFrequenciesSaga),
    fork(watchUpdateUnitFrequenciesSaga),
    fork(watchDeleteUnitFrequenciesSaga),
    fork(watchGetMasterTimeFrameListSaga),
    fork(watchGetMasterTimeFrameDetailsSaga),
    fork(watchAddMasterTimeFrameSaga),
    fork(watchUpdateMasterTimeFrameSaga),
    fork(watchDeleteMasterTimeFrameSaga),
    fork(watchGetLocalSettingsMasterConfigListSaga),
    fork(watchGetConfigItemsCompanyEditableListSaga),
    fork(watchUpdateLocalSettingsMasterConfigToggleSaga),
    fork(watchGetLocalSettingsMasterConfigUserListSaga),
    fork(watchUpdateLocalSettingsMasterConfigUserSaga),
  ]);
}
